module.exports = ".container-fluid,\n.row,\n.row > div {\n  height: 100%; }\n\n.actions .btn {\n  max-width: 45%; }\n\n.actions .btn:last-child {\n    margin-left: auto; }\n\n.hidden {\n  visibility: hidden; }\n\n.form-requied {\n  position: relative; }\n\n.form-requied .fa-asterisk {\n    position: absolute;\n    top: 1.25rem;\n    left: -1rem;\n    -webkit-transform: translateY(-50%);\n            transform: translateY(-50%); }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/timer/timer.component.scss
// module id = ./src/app/timer/timer.component.scss
// module chunks = main